export default {
  computed: {
    currencySymbol() {
      return this.$store.getters["system/currencySymbol"];
    },
    customerData() {
      return this.$store.getters["sessions/getCustomerParam"];
    },
    essentialsData() {
      return this.$store.getters["sessions/getEssentialsData"];
    },
  },
  methods: {
    formatAmount(value, placeholder = "-") {
      return this.checkEmptyAmount(value)
        ? placeholder
        : this.seprateByComma(value);
    },
    formatText(value, placeholder = "-") {
      return this.checkEmpty(value) ? placeholder : value;
    },
    checkEmptyAmount(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      );
    },
    checkEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0) ||
        value == 0 ||
        value == "0"
      );
    },
    seprateByComma(num) {
      return Number(num).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      });
    },
    splitText(val, length = 10) {
      return val.length > length ? `${val.substring(0, length)}...` : val;
    },
    compareDateFromToday(date) {
      if (this.checkEmpty(date)) return false;
      let today = this.$moment();
      return this.$moment(date).isSameOrBefore(today);
    },
  },
};
